export default {
  name: 'WeibyModal',
  props: {
    canCancel: {
      default: () => ['escape', 'outside'],
      type: [Array, Boolean],
    },
    contentPadding: {
      default: 'p-5',
      type: String,
    },
    showFooter: {
      default: true,
      type: Boolean,
    },
    showHeader: {
      default: true,
      type: Boolean,
    },
    showHeaderClose: {
      default: true,
      type: Boolean,
    },
    width: {
      default: 650,
      type: [Number, String],
    },
    type: {
      default: 'primary',
      type: String,
    },
    value: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  beforeDestroy() {
    if (this.$refs?.contentRef) {
      this.$refs.contentRef.removeEventListener('scroll', this.scrollListener);
    }
  },
  mounted() {
    if (this.$refs?.contentRef) {
      this.$refs.contentRef.addEventListener('scroll', this.scrollListener);
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.open = newVal;
      }
    },
  },
  created() {
    this.open = this.value;
  },
  methods: {
    close() {
      this.open = false;
      this.$emit('close');
      this.$emit('input', this.open);
    },
    scrollListener(event) {
      this.$emit('scroll', event);
    },
  },
};
